export {default} from './ResetPassword';



// WEBPACK FOOTER //
// ./src/pages/ResetPassword/index.ts